import React from 'react';
import PropTypes from "prop-types";
import Points from "./graph/Points";
import Circle from "./graph/Circle";
import CheckPoint from "./graph/CheckPoint";

const bigCircleDiameter = 619; // średnica dużego koła w tle
const bigCircleRadius = bigCircleDiameter / 2; // promień dużego koła w tle
const shiftX = 95; // przesunięcie dużego koła w tle od lewej
const shiftY = -30; // przesunięcie dużego koła w tle od góry
const offsetX = 91 + 85; // offset małych kół odpowiedzi
const pointsCoordinates = {
    desktop: { first: { x: 2, y: 300 }, second: { x: 950, y: 300 }},
    mobile: { first: { x: 300, y: 870 }, second: { x: 300, y: 30 }}
};

const countRadius = (percent) => {
    return bigCircleRadius * (percent / 100);
};

const QuestionAnswerGraph = (props) => {
    const coordinates = pointsCoordinates.desktop;

    return (
        <svg viewBox='0 0 1000 650' className={`${props.answered ? 'answered' : ''}`}>
            <Points x={shiftX} y={shiftY}/>
            <g className="answer__rotate">
                <Circle
                    radius={countRadius(props.one)}
                    x={offsetX}
                    y={bigCircleRadius - countRadius(props.one)}
                    text={`${props.one}%`} selected={props.firstSelected} textSize={props.one}
                />
                <Circle
                    radius={countRadius(props.two)}
                    x={offsetX + bigCircleDiameter -  countRadius(props.two) * 2}
                    y={bigCircleRadius - countRadius(props.two)}
                    text={`${props.two}%`} selected={!props.firstSelected} textSize={props.two}
                />
            </g>

            <CheckPoint x={ coordinates.first.x } y={ coordinates.first.y }
                        checked={props.answered && props.firstSelected}
                        highlight={(props.answered && props.firstSelected) || props.answerHover === 1}
                        selected={props.firstSelected} answered={props.answered}
                        showTutorial={props.showTutorial}
                        click={() => props.click(0)} out={props.out} over={() => props.over(1)}
            />

            <CheckPoint x={ coordinates.second.x } y={ coordinates.second.y } align="right"
                        checked={props.answered && !props.firstSelected}
                        highlight={(props.answered && !props.firstSelected) || props.answerHover === 2}
                        selected={!props.firstSelected} answered={props.answered}
                        showTutorial={props.showTutorial}
                        click={() => props.click(1)} out={props.out} over={() => props.over(2)}
            />
        </svg>
    );
};

export default QuestionAnswerGraph;

QuestionAnswerGraph.defaultProps = {
    one: 0,
    two: 0,
    firstSelected: true,
    answerHover: 0,
};

QuestionAnswerGraph.propTypes = {
    one: PropTypes.number,
    two: PropTypes.number,
    firstSelected: PropTypes.bool,
    answerHover: PropTypes.number,
};


// WEBPACK FOOTER //
// ./sources/js/components/Question/QuestionAnswerGraph.js